import React, {useEffect, useState} from 'react';
import {NavigationContainer} from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {useAuthStore} from '../store/useAuthStore';
import AuthNavigator from './AuthNavigator';
import MainNavigator from './MainNavigator';
import StoreSetupNavigator from './StoreSetupNavigator';
import SplashScreen from '../screens/auth/SplashScreen';
import OnboardingScreen from '../screens/auth/OnboardingScreen';

const ONBOARDING_KEY = '@fabtailor_onboarding_seen';

const RootNavigator = () => {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const hasStore = useAuthStore(state => state.hasStore);
  const loadStoredAuth = useAuthStore(state => state.loadStoredAuth);

  const [splashDone, setSplashDone] = useState(false);
  const [hasSeenOnboarding, setHasSeenOnboarding] = useState(false);

  useEffect(() => {
    Promise.all([
      loadStoredAuth(),
      AsyncStorage.getItem(ONBOARDING_KEY),
      new Promise(resolve => setTimeout(resolve, 1500)),
    ]).then(([, onboardingValue]) => {
      setHasSeenOnboarding(onboardingValue === 'true');
      setSplashDone(true);
    });
  }, [loadStoredAuth]);

  const markOnboardingSeen = () => {
    AsyncStorage.setItem(ONBOARDING_KEY, 'true');
    setHasSeenOnboarding(true);
  };

  if (!splashDone) {
    return <SplashScreen />;
  }

  if (!hasSeenOnboarding) {
    return <OnboardingScreen onDone={markOnboardingSeen} />;
  }

  const getNavigator = () => {
    if (!isAuthenticated) return <AuthNavigator />;
    if (hasStore === false) return <StoreSetupNavigator />;
    return <MainNavigator />;
  };

  return <NavigationContainer>{getNavigator()}</NavigationContainer>;
};

export default RootNavigator;
